// its using the old namespace and shit gotta tidy up
import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Textarea } from '@/components/ui/textarea';
import { DatePicker } from '@/components/ui/date-picker';
import { Loader2, CheckCircle2 } from 'lucide-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark, faClipboardCheck } from '@awesome.me/kit-269fbef2e2/icons/duotone/solid';
import { cn } from '@/lib/utils';
//
import Firebase from 'firebase/compat/app'; // If not already imported for FieldValue
import { db, storage, auth } from '@/js/external-js/config/main_config';
import { Timestamp } from 'firebase/firestore';
import { openModal } from '@/js/external-js/variableModules/utils/openModal.util';
import { SupportingDocs } from '@/js/external-js/variableModules/namespaces/SupportingDocs.namespace';
import { createDocument, linkEvidenceToSource } from '@/services/documentsService';
import { MeetingAgendaModal } from '@/components/meeting-agenda';

interface PerformTaskDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  selectedEvent?: {
    title?: string;
    description?: string;
    date?: string;
    specialType?: 'meeting-agenda' | 'changes-3m' | 'changes-6m';
    componentId?: string;
    id?: string;
    checkDetail?: { evidence?: string };
    rawData?: { checkDetail?: { evidence?: string } };
  };
  onDataChanged?: () => void;
  // setEvents?: (events: Record<string, any>) => void;
  onTaskPerformed?: () => void; // Callback for when a task is performed
}

interface TaskFormData {
  action: string;
  datePerformed: Date;
  changes3m: string;
  changes6m: string;
  comments: string;
  dataClassification: string;
}

function generateGUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

const PerformTaskDialog: React.FC<PerformTaskDialogProps> = ({ open, onOpenChange, selectedEvent, onDataChanged, onTaskPerformed }) => {
  const [isMeetingAgendaOpen, setIsMeetingAgendaOpen] = React.useState(false);
  // Reset all dialog state when dialog opens or selectedEvent changes
  React.useEffect(() => {
    if (!open) return;
    setFormData({
      action: 'Sight Evidence',
      datePerformed: selectedEvent?.date ? new Date(selectedEvent.date) : new Date(),
      changes3m: '',
      changes6m: '',
      comments: '',
      dataClassification: 'Customer Confidential'
    });
    if (selectedEvent?.componentId) {
      // onDataChanged?.();
    }
    setSupportingDocs([]);
    setUploading(false);
    setUploadError(null);
    // Add any other state resets as needed
  }, [open, selectedEvent]);
  const specialType = selectedEvent?.specialType;
  const taskId = selectedEvent?.componentId || selectedEvent?.id || '';
  console.log('[AssuranceTask] selectedEvent:', selectedEvent);
  // Form state
  const [formData, setFormData] = React.useState<TaskFormData>({
    action: 'Sight Evidence',
    datePerformed: selectedEvent?.date ? new Date(selectedEvent.date) : new Date(),
    changes3m: '',
    changes6m: '',
    comments: '',
    dataClassification: 'Customer Confidential'
  });

  // Evidence upload state
  const [classifications, setClassifications] = React.useState<string[]>([]);
  const [supportingDocs, setSupportingDocs] = React.useState<File[]>([]);
  const [uploading, setUploading] = React.useState(false);
  const [uploadError, setUploadError] = React.useState<string | null>(null);
  const fileInputRef = React.useRef<HTMLInputElement | null>(null);

  React.useEffect(() => {
    const fetchClassifications = async () => {
      try {
        const assetMenu = await (window as any).AssetRegister.Asset.Menu();
        //change back to not no no
        const fallback = ['Customer Confidential', 'Business Confidential', 'Public'];
        const list = assetMenu?.classification;
        setClassifications(Array.isArray(list) ? list : fallback);
      } catch (error) {
        //change back to not not 
        setClassifications(['Customer Confidential', 'Business Confidential', 'Public']);
      }
    };

    if (open) fetchClassifications();
  }, [open]);

  const handleFileChange = React.useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      setSupportingDocs(prev => {
        const newFiles = Array.from(e.target.files);
        // Prevent duplicates (by name + size)
        const fileMap = new Map(prev.map(f => [f.name + f.size, f]));
        for (const file of newFiles) {
          fileMap.set(file.name + file.size, file);
        }
        return Array.from(fileMap.values());
      });
    }
  }, []);
  const handleAttachDocument = React.useCallback(() => {
    fileInputRef.current?.click();
  }, []);
  const getFileIcon = React.useCallback((file: File) => {
    const ext = file.name.split('.').pop()?.toLowerCase();
    if (file.type.startsWith('image/')) {
      return <img src={URL.createObjectURL(file)} alt={file.name} className="w-12 h-12 object-cover rounded border" />;
    }
    if (ext === 'pdf') return <span className="flex items-center justify-center w-12 h-12 bg-red-100 text-red-600 rounded text-xs font-semibold">PDF</span>;
    if (["doc", "docx"].includes(ext || '')) return <span className="flex items-center justify-center w-12 h-12 bg-blue-100 text-blue-600 rounded text-xs font-semibold">DOC</span>;
    if (["xls", "xlsx", "csv"].includes(ext || '')) return <span className="flex items-center justify-center w-12 h-12 bg-green-100 text-green-600 rounded text-xs font-semibold">XLS</span>;
    return <span className="flex items-center justify-center w-12 h-12 bg-gray-100 text-gray-500 rounded text-xs font-semibold">TXT</span>;
  }, []);

  // Add remove handler for attachments
  const handleRemoveAttachment = React.useCallback((fileToRemove: File) => {
    setSupportingDocs(prev => prev.filter(f => !(f.name === fileToRemove.name && f.size === fileToRemove.size)));
  }, []);

  // const handleAgendaClick = async () => {
  //   const agenda = new MeetingAgenda();
  //   agenda.attachToWindow();
  //   await agenda.createPopout();
  // };

  // Reset supporting docs when the dialog closes
  React.useEffect(() => {
    if (!open) {
      setSupportingDocs([]);
    }
  }, [open]);

  const [datePerformed, setDatePerformed] = React.useState<Date>(
    selectedEvent?.date ? new Date(selectedEvent.date) : new Date()
  );

  React.useEffect(() => {
    setFormData(prev => ({ ...prev, datePerformed }));
  }, [datePerformed]);


  const handlePerformTask = async () => {
    try {
      setUploading(true);
      await handleUploadSupportingDocs();
      const companyID = (window as any).companyID;
      const performedBy = auth.currentUser?.uid || '';

      const docRef = db.collection('customers').doc(companyID).collection('compliance').doc('assurance');
      const assuranceDoc = await docRef.get();

      if (!assuranceDoc.exists) throw new Error('No assurance document found');

      const assuranceData = assuranceDoc.data();
      const currentTask = assuranceData?.[taskId];
      if (!currentTask) throw new Error('Task not found in assurance data');

      const checkDays = parseInt(currentTask.checkFrequency.checkDays || '90');
      const lastCheckMap = currentTask.checkFrequency.lastCheck || {};
      const historyMap = currentTask.checkHistory || {};

      const numberPreviousChecks = parseInt(currentTask.checkHistory?.numberPreviousChecks || '0');
      const newCheckIndex = numberPreviousChecks + 1;
      let performedDate = formData.datePerformed;
      if (!(performedDate instanceof Date) || isNaN(performedDate.getTime())) {
        performedDate = new Date();
      }
      // Add current time to performedDate
      let today = new Date();
      performedDate.setHours(today.getHours(), today.getMinutes(), today.getSeconds(), today.getMilliseconds());
      const nextReview = new Date(performedDate);
      nextReview.setDate(nextReview.getDate() + checkDays);
      console.log(' 👨🏽‍🦽‍➡️taskId:', taskId);
      console.log(' 👨🏽‍🦽‍➡️newCheckIndex:', newCheckIndex);


      const evidencePaths: string[] = [];
      for (const file of supportingDocs) {
        const ref = storage.ref(`/customers/${companyID}/compliance/assurance/${taskId}/${newCheckIndex}/${file.name}`);
        await ref.put(file);
        evidencePaths.push(ref.fullPath);
      }

      let scheduledDateRaw = performedDate;
      if (
        currentTask.checkFrequency &&
        currentTask.checkFrequency.nextCheck &&
        typeof currentTask.checkFrequency.nextCheck.toDate === 'function'
      ) {
        const d = currentTask.checkFrequency.nextCheck.toDate();
        if (d instanceof Date && !isNaN(d.getTime())) {
          scheduledDateRaw = d;
        }
      }

      const newEntry: any = {
        assignedTo: currentTask.checkHistory?.['1']?.assignedTo || '',
        check: currentTask.checkDetail?.check || '',
        comments: formData.comments,
        dataClassification: formData.dataClassification,
        evidence: evidencePaths,
        lastCheck: Timestamp.now(),
        checkStatus: 'complete',
        performedDate: Timestamp.fromDate(performedDate),
        performedBy,
        scheduledDate: Timestamp.fromDate(scheduledDateRaw),
      };

      if (specialType === 'changes-3m') newEntry.amountOfChangesRecorded = formData.changes3m;
      if (specialType === 'changes-6m') newEntry.amountOfIncidentsRecorded = formData.changes6m;

      await docRef.update({
        [`${taskId}.checkHistory`]: {
          ...historyMap,
          numberPreviousChecks: newCheckIndex.toString(),
          [newCheckIndex]: newEntry
        },
        [`${taskId}.checkFrequency.lastCheck`]: {
          ...lastCheckMap,
          [newCheckIndex]: { checkDate: Timestamp.fromDate(performedDate) }
        },
        [`${taskId}.checkFrequency.nextCheck`]: Timestamp.fromDate(nextReview),
      });

      setUploading(false);
      // DED-1979: Call callbacks to refresh data in parent components
      if (typeof onDataChanged === 'function') onDataChanged();
      if (typeof onTaskPerformed === 'function') onTaskPerformed();
      onOpenChange(false);
    } catch (err: any) {
      console.error('[PerformTask] ❌ Error submitting task:', err);
      setUploadError(err.message || 'An error occurred while submitting.');
      setUploading(false);
    }
  };

  const handleUploadSupportingDocs = React.useCallback(async () => {
    try {
      // setUploading(true);
      // setUploadError(null);
      const currentUser = auth.currentUser;
      const companyID = (window as any).companyID;

      // Fetch task data to inherit procRef and relatedControls
      const docRef = db.collection('customers').doc(companyID).collection('compliance').doc('assurance');
      const assuranceDoc = await docRef.get();
      const assuranceData = assuranceDoc.data();
      const currentTask = assuranceData?.[taskId];
      
      // Extract procRef and relatedControls from the task
      const taskProcRef = currentTask?.checkDetail?.procRef || [];
      const taskRelatedControls = currentTask?.checkDetail?.relatedControls || [];

      for (const file of supportingDocs) {
        const docID = generateGUID();
        // const nextID = await SupportingDocs.Document.getNextAvailableDocID();
        let nextReviewDate = new Date();
        nextReviewDate.setDate(nextReviewDate.getDate() + 365);
        const newDoc = new SupportingDocs.Document();
        newDoc.classification = formData.dataClassification;
        newDoc.comments = formData.comments;
        newDoc.relatedTask = selectedEvent?.id || '';
        // DED-1472: Add source task information for MCM linking
        newDoc.sourceTaskId = taskId;
        newDoc.sourceTaskTitle = selectedEvent?.title || '';
        // Link back to the task this evidence was uploaded from
        newDoc.linkedFromTaskId = taskId;
        newDoc.confluenceURL = '';
        newDoc.dateUploaded = Timestamp.fromDate(new Date());
        newDoc.docHash = '';
        // DED-943: Use 'Task Evidence' type for documents uploaded during task performance
        newDoc.documentType = 'Task Evidence';
        newDoc.fileName = file.name;
        newDoc.lastReviewDate = Timestamp.fromDate(new Date());
        newDoc.msgPages = [];
        newDoc.nextReviewDate = Timestamp.fromDate(nextReviewDate);
        // DED-1968: Inherit procRef and relatedControls from the task
        newDoc.procRef = taskProcRef;
        newDoc.relatedControls = taskRelatedControls;
        newDoc.updateMethod = '';
        newDoc.updatedBy = currentUser?.uid || '';
        newDoc.uploadedBy = currentUser?.uid || '';
        newDoc.companyID = companyID;
        newDoc.edit = false;

        // Create the document
        const createdDoc = await createDocument(newDoc, file);
        
        // DED-1472: Link evidence back to the source task using MCM
        if (createdDoc?.docID && taskId) {
          await linkEvidenceToSource(
            createdDoc.componentId || `SUP-${createdDoc.docID}`,
            {
              sourceType: 'task',
              sourceId: taskId,
              sourceTitle: selectedEvent?.title || `Task ${taskId}`,
            },
            companyID
          );
        }
      }

      setSupportingDocs([]);
    } catch (e: any) {
      setUploadError(e?.message || 'Failed to upload one or more documents');
    } finally {
      // setUploading(false);
    }
  }, [supportingDocs, formData, selectedEvent]);


  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent 
        className="max-w-4xl! w-full max-h-[90vh] overflow-hidden rounded-2xl border border-border bg-card sm:p-0! shadow-2xl [&>button]:hidden p-0"
        onOpenAutoFocus={(e) => e.preventDefault()}
      >
        <div className="flex flex-col h-full max-h-[90vh] p-0">
          {/* Close button */}
          <button
            type="button"
            onClick={() => onOpenChange(false)}
            disabled={uploading}
            className="absolute right-3 top-3 z-50 h-8 w-8 rounded-lg bg-muted hover:bg-muted/80 flex items-center justify-center transition-colors disabled:opacity-50"
            aria-label="Close"
          >
            <FontAwesomeIcon icon={faXmark} className="h-4 w-4 text-muted-foreground" />
          </button>
          
          {/* Header */}
          <div className="px-6 py-5 border-b border-border bg-card text-center shrink-0">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-linear-to-br from-emerald-500/10 to-emerald-500/30 mb-4">
              <FontAwesomeIcon icon={faClipboardCheck} className="w-8 h-8 text-emerald-500" />
            </div>
            <h2 className="text-3xl font-bold text-foreground">{selectedEvent?.title || 'Perform Task'}</h2>
            <p className="mt-3 text-muted-foreground max-w-md mx-auto">
              Record the action, attach evidence, and add comments.
            </p>
          </div>

          {/* Content */}
          <div className="px-6 py-5 flex-1 min-h-0 overflow-y-auto space-y-4">
            <div className="rounded-lg border border-border bg-muted/30 p-4">
              <Label className="block text-sm font-semibold text-foreground mb-3">
                Task
              </Label>
              <Textarea id="task" value={selectedEvent?.description || ''} readOnly className="bg-background border-border min-h-[40px] max-h-[200px] resize-y" data-force-isms-override />
            </div>
            <div className="rounded-lg border border-border bg-muted/30 p-4">
              <Label className="block text-sm font-semibold text-foreground mb-3">
                Action
              </Label>
              <Select
                value={formData.action}
                onValueChange={(val) =>
                  setFormData((prev) => ({ ...prev, action: val }))
                }
              >
                <SelectTrigger className="bg-background border-border h-11">
                  <SelectValue placeholder="Select Action" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="Upload Evidence">Upload Evidence</SelectItem>
                  <SelectItem value="Sight Evidence">Sight Evidence</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div className="rounded-lg border border-border bg-muted/30 p-4">
              <Label className="block text-sm font-semibold text-foreground mb-3">
                Date Performed
              </Label>
              <DatePicker date={datePerformed} setDate={setDatePerformed} fullWidth enableNaturalInput showPreview placeholder="Type 'tomorrow' or pick a date" />
            </div>
            {/* Evidence Upload - Attach Supporting Doc UI */}
            <div className="rounded-lg border border-border bg-muted/30 p-4">
              <Label className="block text-sm font-semibold text-foreground mb-3">
                Uploaded Evidence
              </Label>
              <div>
                <input
                  ref={fileInputRef}
                  id="evidence"
                  type="file"
                  multiple
                  className="hidden"
                  onChange={handleFileChange}
                />
                <Button type="button" variant="outline" onClick={handleAttachDocument} className="mb-2">
                  Attach Supporting Document
                </Button>
                <div className="flex flex-wrap gap-2">
                  {supportingDocs.map((file, idx) => (
                    <div key={file.name + file.size + idx} className="flex flex-col items-center border rounded p-2 bg-gray-50 relative group">
                      {getFileIcon(file)}
                      <span className="text-xs mt-1 max-w-[80px] truncate" title={file.name} data-force-isms-override>{file.name}</span>
                      <button
                        type="button"
                        className="absolute top-0 right-0 m-1 p-1 rounded-full bg-white text-gray-500 hover:text-red-600 hover:bg-red-100 shadow group-hover:block"
                        style={{ display: 'block' }}
                        title="Remove attachment"
                        onClick={() => handleRemoveAttachment(file)}
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-4 h-4">
                          <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                      </button>
                    </div>
                  ))}
                </div>
                {uploadError && <div className="text-xs text-red-500 mt-1">{uploadError}</div>}
              </div>
            </div>
            <div className="rounded-lg border border-border bg-muted/30 p-4">
              <Label className="block text-sm font-semibold text-foreground mb-3">
                Data Classification
              </Label>
              <Select
                value={formData.dataClassification}
                onValueChange={(val) =>
                  setFormData((prev) => ({ ...prev, dataClassification: val }))
                }
              >
                <SelectTrigger className="bg-background border-border h-11">
                  <SelectValue placeholder="Select Data Classification" />
                </SelectTrigger>
                <SelectContent>
                  {classifications.map((value) => (
                    <SelectItem key={value} value={value}>
                      {value}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
            {/* Special fields: Only one shows at a time based on specialType */}
            {selectedEvent?.id === 'ass049' && (
              <div className="rounded-lg border border-border bg-muted/30 p-4">
                <Label className="block text-sm font-semibold text-foreground mb-3">
                  Meeting Agenda
                </Label>
                <div>
                  <Button type="button" variant="outline" onClick={() => setIsMeetingAgendaOpen(true)} className="mr-3">
                    Generate Meeting Agenda
                  </Button>
                  <MeetingAgendaModal
                    isOpen={isMeetingAgendaOpen}
                    onClose={() => setIsMeetingAgendaOpen(false)}
                  />
                  <div className="mt-2">
                    <Textarea
                      id="agenda-notes"
                      placeholder="Add any additional notes or comments about the meeting agenda..."
                      className="w-full"
                      value={formData.comments}
                      onChange={(e) => setFormData(prev => ({ ...prev, comments: e.target.value }))}
                    />
                  </div>
                </div>
              </div>
            )}
            {selectedEvent?.title === 'Log how many changes occurred in the last 3 months' && (
              <div className="rounded-lg border border-border bg-muted/30 p-4">
                <Label className="block text-sm font-semibold text-foreground mb-3">
                  Changes (3 months)
                </Label>
                <div>
                  <Textarea
                    id="changes3m"
                    rows={4}
                    placeholder="Describe changes performed in the last 3 months..."
                    value={formData.changes3m}
                    onChange={(e) => setFormData(prev => ({ ...prev, changes3m: e.target.value }))}
                    className="w-full"
                  />
                </div>
              </div>
            )}
            {selectedEvent?.title === 'Log how many incidents occurred in the last 3 months' && (
              <div className="rounded-lg border border-border bg-muted/30 p-4">
                <Label className="block text-sm font-semibold text-foreground mb-3">
                  Incidents (3 months)
                </Label>
                <div>
                  <Textarea
                    id="changes6m"
                    rows={4}
                    placeholder="Describe incidents occured in the last 3 months..."
                    value={formData.changes6m}
                    onChange={(e) => setFormData(prev => ({ ...prev, changes6m: e.target.value }))}
                    className="w-full"
                  />
                </div>
              </div>
            )}
            <div className="rounded-lg border border-border bg-muted/30 p-4">
              <Label className="block text-sm font-semibold text-foreground mb-1">
                Comments
              </Label>
              <p className="text-xs text-muted-foreground mb-3">
                Explain the uploaded evidence or why there is no evidence to upload
              </p>
              <Textarea
                id="comments"
                placeholder="Add notes about the task..."
                value={formData.comments}
                onChange={(e) => setFormData(prev => ({ ...prev, comments: e.target.value }))}
                className="bg-background border border-border min-h-[100px] focus:border-primary"
              />
            </div>
          </div>

          {/* Footer */}
          <div className="px-6 py-4 border-t border-border bg-muted/30 shrink-0">
            <div className="flex items-center justify-between gap-4">
              <div className="text-xs text-muted-foreground truncate">
                {(selectedEvent?.componentId || selectedEvent?.id) && `ID: ${selectedEvent?.componentId || selectedEvent?.id}`}
              </div>
              <div className="flex gap-2 shrink-0">
                <Button
                  type="button"
                  variant="outline"
                  size="sm"
                  onClick={() => onOpenChange(false)}
                  disabled={uploading}
                >
                  Cancel
                </Button>
                <Button
                  size="sm"
                  onClick={async () => {
                    setUploading(true);
                    setUploadError(null);
                    try {
                      await handlePerformTask();
                      onOpenChange(false);
                    } catch (err: any) {
                      setUploadError(err.message || 'Failed to perform task');
                    } finally {
                      setUploading(false);
                    }
                  }}
                  disabled={uploading}
                  className="bg-primary hover:bg-primary/80 text-white"
                >
                  {uploading ? (
                    <>
                      <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                      Performing...
                    </>
                  ) : (
                    <>
                      <CheckCircle2 className="w-4 h-4 mr-2" />
                      Perform Task
                    </>
                  )}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PerformTaskDialog;

